import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CpslSpinner, CpslText } from '@usecapsule/react-components';
import { Heading, SpinnerContainer, StepContainer, InnerStepContainer } from '../common.js';
export const Waiting = ({ heading, subheading }) => {
    return (_jsxs(StepContainer, { "$wide": true, children: [_jsx(SpinnerContainer, { children: _jsx(CpslSpinner, { size: 100 }) }), _jsxs(InnerStepContainer, { children: [_jsx(Heading, { variant: "headingS", weight: "bold", children: heading }), _jsx(CpslText, { variant: "bodyS", color: "secondary", weight: "medium", children: subheading })] })] }));
};
